import React, {Component} from 'react';
import { withScriptjs, withGoogleMap, GoogleMap, Marker, DirectionsRenderer, InfoWindow } from "react-google-maps"
import PointP from '../../img/pointP.png'

const google = window.google;

const pointP = { url: PointP, scaledSize: new google.maps.Size(20, 20) };
class MapaModal extends Component{
  constructor(props){
    super(props);
    this.state={
      pasado:0
    }
  }

  componentDidMount(){
    let {markers} = this.props;
    const bounds = new window.google.maps.LatLngBounds();
    markers.map((hotel, i) => {
      bounds.extend(new window.google.maps.LatLng(
        hotel.coordenadas.lat,
        hotel.coordenadas.lng
      ));
    });
    this.refs.map.fitBounds(bounds)
  }

  onToggleOpenVC = (index) =>{
    let { pasado } = this.state;
    let id3 = 'emple'+index;
    if(id3 !== pasado ){
      this.setState({[id3]:!this.state[id3], [pasado]:false, pasado:id3 });
    }
    else{
      this.setState({[id3]:!this.state[id3], pasado:id3 });
    }
}


  render(){
      let {markers, direccion, isMulti, paradasW} = this.props;
    return(
      <div>
        <GoogleMap
          ref='map'
          defaultZoom={12}
          center={this.props.coordenadas}
          onClick={this.props.setMarker}>

          {paradasW.map((snap,index) => {
            return (
              <Marker key={'keyM' + index} onClick={() => this.onToggleOpenVC(index)} icon={pointP} position={snap.location} >
                {
                  this.state['emple' + index] &&
                  <InfoWindow onCloseClick={() => this.onToggleOpenVC(index)}>
                    <div>
                      {' '}
                      {snap.name}
                    </div>
                  </InfoWindow>
                }
              </Marker>
            )
          })}

          {(!isMulti) &&
            <DirectionsRenderer options={{ suppressMarkers: true }} directions={direccion} />
          }
          {(isMulti) &&
            <div>
              {direccion.map((snap, index) => {
                return (
                  <DirectionsRenderer index options={{ suppressMarkers: true }} directions={snap} />
                )
              })}
            </div>
          }
        </GoogleMap>
      </div>
    )
  }
}
export default withGoogleMap(MapaModal);


// WEBPACK FOOTER //
// ./src/Components/Rutas/mapaRutasE.js